'use strict';

const slugify = require('slugify');

module.exports = {
  generate: (string) => {
    return slugify(string, {
      replacement: '-',           // replace spaces with replacement
      remove: /[_/*+~.()'"!:@]/g, // regex to remove characters
      lower: true                 // result in lower case
    });
  }
};